import { Annotation } from "./annotation.js";
import { HighlightAnnotation } from "./highlightAnnotation.js";
import { AnnotationMemory } from "./annotationMemory.js";
export default class AnnotationLayer {
    constructor(annotationListener, textListener, canvasListener, zoom, scale, pageWidthIncreasePerZoom, orientation) {
        this.annotationMemory = new AnnotationMemory(orientation)
        this.annotationListener = annotationListener
        this.textListener = textListener
        this.canvasListener = canvasListener
        this.zoom = zoom // todo
        this.scale = scale
        this.pageWidthIncreasePerZoom = pageWidthIncreasePerZoom
        this.orientation = orientation // todo
        this.drawType = null
        this.options = null
        this.toolSize = null
        this.selectedAnnotation = null
        this.selectedAnnotationIndex = 0
        this.painting = false
        this.firstX = 0
        this.lastX = 0
        this.firstY = 0
        this.lastY = 0
        this.linesSelected = 0
        this.drawingArray = []
        this.drawingLastX = 0
        this.drawingLastY = 0
        this.scaleSomething = 2
        this.drawingCanvas = null
        this.currentHLColor = ""
        this.lastEvent = ""
        this.newHLDivs = []
        this.zoomOptions = {}
        this.cursor = null
        this.clearToolCircleRadius = 15
        this.TTSSpeed = 3
        this.TTSVolume = 3
        this.TTSVoice = null
        this.TTSGreetings = null
        this.TTSSynth = null

        /* EVENTS */
        this.squareDrawEventHandler = (e) => {
            let cBound = this.annotationListener.getBoundingClientRect()
            let x = e.clientX - cBound.left
            let y = e.clientY - cBound.top
            var annotation = new Annotation("square", this.annotationListener, this.toolSize, [x, y], this.options, this.zoomOptions, this.orientation, this.annotationMemory.getLastId() + 1)
            this.annotationMemory.addAnnotation(annotation)
            this.lastEvent = "square"
        }

        this.circleDrawEventHandler = (e) => {
            let cBound = this.annotationListener.getBoundingClientRect()
            let x = e.clientX - cBound.left
            let y = e.clientY - cBound.top
            var annotation = new Annotation("circle", this.annotationListener, this.toolSize, [x, y], this.options, this.zoomOptions, this.orientation, this.annotationMemory.getLastId() + 1)
            this.annotationMemory.addAnnotation(annotation)
            this.lastEvent = "circle"
        }

        this.textDrawEventHandler = (e) => {
            let cBound = this.annotationListener.getBoundingClientRect()
            let x = e.clientX - cBound.left
            let y = e.clientY - cBound.top
            var annotation = new Annotation("text", this.annotationListener, this.toolSize, [x, y], this.options, this.zoomOptions, this.orientation, this.annotationMemory.getLastId() + 1)
            this.annotationMemory.addAnnotation(annotation)
            this.textListener.style.cursor = "auto"
            this.eventDestroyers()
            this.lastEvent = "text"
        }

        this.highlight2DrawMouseDownEventHandler = (e) => {
            var ss = document.styleSheets[0]
            if ("insertRule" in ss) {
                
                for (var i = 0; i < ss.cssRules.length; i++) {
                    var rule = ss.cssRules[i]
                    if (rule.selectorText == "span::selection") {
                        ss.deleteRule(i) 
                    }
                }
                var newRule = 'span::selection { background: ' + this.options.color + '!important; }'
                ss.insertRule(newRule, 0)
            }
            this.textListener.style.userSelect = ''
        }

        this.highlight2DrawMouseUpEventHandler = (e) => {
            this.painting = false
            var selectionObject = JSON.parse(JSON.stringify(window.getSelection().getRangeAt(0).getClientRects()))
            var selection = [];
            this.options = {
                color: this.currentHLColor
            }
            
            Object.keys(selectionObject).forEach((key) => {
                selection.push(selectionObject[key])
            });

            if (selection != null && selection.length > 0) {
                var cBound = null
                cBound = this.annotationListener.getBoundingClientRect()
                this.options.pageOffset = cBound.left
                this.options.pageTopOffset = cBound.top
                var indexesToDelete = []

                for (var [index, rect] of selection.entries()) {
                    if (rect.width == 0 || rect.height == 0) {
                        indexesToDelete.push(index)
                    }
                }               

                for (var i = indexesToDelete.length - 1; i >= 0; i--) {
                    selection.splice(indexesToDelete[i], 1)
                }
               
                var annotation = new HighlightAnnotation("highlight", this.annotationListener, null, selection, this.options, this.zoomOptions, this.orientation, this.annotationMemory.getLastId() + 1)
                this.annotationMemory.addAnnotation(annotation)
                window.getSelection().empty()
            }
            this.textListener.style.userSelect = 'none'
        }

        this.circleFollowMouse = (e) => {
            this.cursor.style.display = 'block';
            this.cursor.style.left = e.clientX - this.clearToolCircleRadius + "px";
            this.cursor.style.top = e.clientY - this.clearToolCircleRadius + "px";
        }
        
        this.circleFollowMouseOut = (e) => {
            this.cursor.style.display = 'none';
        }

        this.clearToolMouseDownEventHandler = (e) => {
            this.painting = true
        }
        
        this.clearToolMouseMoveEventHandler = (e) => {
            if (this.painting == true) {
                const cBound = this.annotationListener.getBoundingClientRect()
                let x1 = e.clientX - this.clearToolCircleRadius
                let y1 = e.clientY - this.clearToolCircleRadius
                let x2 = e.clientX + this.clearToolCircleRadius
                let y2 = e.clientY + this.clearToolCircleRadius
                this.annotationMemory.removeAnnotationWithClearTool(x1, y1, x2, y2, cBound)
            }
        }
        
        this.clearToolMouseUpEventHandler = (e) => {
            this.painting = false
        }

        this.deselectAllAnnotations = (e) => {
            for (var annotation of this.annotationMemory.getAnnotationArray()) {
                if (annotation.selected && annotation.type != "highlight" && this.annotationMemory.clearMode == false) {
                    annotation.removeHitbox()
                }
            }
        }
        
        this.drawingDrawMouseDownEventHandler = (e) => {
            this.painting = true;
            if (this.drawingCanvas == null) return
            let cBound = this.drawingCanvas.getBoundingClientRect()
            this.drawingLastX = (e.clientX - cBound.left)
            this.drawingLastY = (e.clientY - cBound.top)
        }

        this.drawingDrawMouseMoveEventHandler = (e) => {
            if (this.painting == true) {
                if (this.drawingCanvas == null) return
                var ctx = this.drawingCanvas.getContext("2d")
                ctx.fillStyle = this.options.color
                let cBound = this.drawingCanvas.getBoundingClientRect()
                
                let mouseX = (e.clientX - cBound.left)
                let mouseY = (e.clientY - cBound.top)

                var x1 = mouseX,
                    x2 = this.drawingLastX,
                    y1 = mouseY,
                    y2 = this.drawingLastY;

                var steep = (Math.abs(y2 - y1) > Math.abs(x2 - x1));
                var x, y = 0
                if (steep) {
                    x = x1;
                    x1 = y1;
                    y1 = x;
              
                    y = y2;
                    y2 = x2;
                    x2 = y;
                  }
                if (x1 > x2) {
                    x = x1;
                    x1 = x2;
                    x2 = x;
                
                    y = y1;
                    y1 = y2;
                    y2 = y;
                }

                var dx = x2 - x1,
                    dy = Math.abs(y2 - y1),
                    error = 0,
                    de = dy / dx,
                    yStep = -1,
                    y = y1;

                if (y1 < y2) {
                    yStep = 1;
                }

                var lineThickness = parseInt(this.options.lineThickness) - Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1)) / 10;
                if (lineThickness < 1) {
                    lineThickness = 1;
                }
                for (var x = x1; x < x2; x++) {
                    if (steep) {
                      ctx.fillRect(y, x, lineThickness, lineThickness);
                    } else {
                      ctx.fillRect(x, y, lineThickness, lineThickness);
                    }
              
                    error += de;
                    if (error >= 0.5) {
                      y += yStep;
                      error -= 1.0;
                    }
                }

                this.drawingLastX = mouseX;
                this.drawingLastY = mouseY;

                this.drawingArray.push([mouseX, mouseY])

            }
        }

        this.drawingDrawMouseUpEventHandler = (e) => {
            this.painting = false

            if (this.drawingArray.length > 0) {
                let annotation = new Annotation("drawing", this.annotationListener, this.toolSize, this.drawingArray, this.options, this.zoomOptions, this.orientation, this.annotationMemory.getLastId() + 1)
                this.annotationMemory.addAnnotation(annotation)

                this.drawingArray = []
                this.drawingLastX = 0
                this.drawingLastY = 0
            }

            if (this.drawingCanvas == null) return
            var ctx = this.drawingCanvas.getContext("2d")
            ctx.clearRect(0, 0, this.drawingCanvas.width, this.drawingCanvas.height);
            this.lastEvent = "drawing"

        }

        this.saySomething = (e) => {
            if (this.TTSSynth) this.TTSSynth.cancel()
            this.TTSGreetings.text = window.getSelection().toString()
            this.TTSGreetings.voice = this.TTSVoice
            this.TTSGreetings.rate = this.TTSSpeed / 10
            this.TTSGreetings.volume = this.TTSVolume / 10
            this.TTSSynth.speak(this.TTSGreetings)
        }

        /* INIT */
        this.init()
    }

    getWordAtPoint(elem, x, y) {
        if(elem.nodeType == elem.TEXT_NODE) {
          var range = elem.ownerDocument.createRange();
          range.selectNodeContents(elem);
          var currentPos = 0;
          var endPos = range.endOffset;
          while(currentPos+1 < endPos) {
            range.setStart(elem, currentPos);
            range.setEnd(elem, currentPos+1);
            if(range.getBoundingClientRect().left <= x && range.getBoundingClientRect().right  >= x &&
               range.getBoundingClientRect().top  <= y && range.getBoundingClientRect().bottom >= y) {
              range.expand("word");
              var ret = range.toString();
              range.detach();
              return {word: ret, coords: [range.getBoundingClientRect().left, range.getBoundingClientRect().top, range.getBoundingClientRect().right, range.getBoundingClientRect().bottom]};
            }
            currentPos += 1;
          }
        } else {
          for(var i = 0; i < elem.childNodes.length; i++) {
            var range = elem.childNodes[i].ownerDocument.createRange();
            range.selectNodeContents(elem.childNodes[i]);
            if(range.getBoundingClientRect().left <= x && range.getBoundingClientRect().right  >= x &&
               range.getBoundingClientRect().top  <= y && range.getBoundingClientRect().bottom >= y) {
              range.detach();
              return(this.getWordAtPoint(elem.childNodes[i], x, y));
            } else {
              range.detach();
            }
          }
        }
        return(null);
    }

    init() {
        this.zoomOptions = {
            zoom: this.zoom,
            scale: this.scale,
            pageWidthIncreasePerZoom: this.pageWidthIncreasePerZoom
        }
        var height = this.textListener.getBoundingClientRect().height
        var width = this.textListener.getBoundingClientRect().width
        this.annotationListener.style.minHeight = height-2 + "px"
        this.annotationListener.style.maxHeight = height-2 + "px"
        this.annotationListener.style.minWidth = width-2 + "px"
        this.annotationListener.style.maxWidth = width-2 + "px"
        this.eventCreators()
        // todo set canvas stuff
    } 
    
    updateLayer() {
        this.zoomOptions = {
            zoom: this.zoom,
            scale: this.scale,
            pageWidthIncreasePerZoom: this.pageWidthIncreasePerZoom
        }
        var height = this.textListener.getBoundingClientRect().height
        var width = this.textListener.getBoundingClientRect().width
        this.annotationListener.style.minHeight = height-2 + "px"
        this.annotationListener.style.maxHeight = height-2 + "px"
        this.annotationListener.style.minWidth = width-2 + "px"
        this.annotationListener.style.maxWidth = width-2 + "px"
        this.annotationMemory.annotationZoom(this.zoomOptions)
        this.eventCreators()
    }

    /* MODES */
    setClickMode(drawEvent, toolSize, options = null) {
        // this.drawType = drawtype
        this.toolSize = toolSize
        this.options = options

        

        // destroy all event listeners
        this.deselectTool()

        if (drawEvent == "square") {
            this.textListener.addEventListener("click", this.squareDrawEventHandler, true)
        }

        if (drawEvent == "circle") {
            this.textListener.addEventListener("click", this.circleDrawEventHandler, true)
        }

        // if (drawEvent == "highlight") {
        //     this.textListener.addEventListener("click", this.highlightDrawMouseClickEventHandler, true)
        // }

        if (drawEvent == "highlight") {
            this.currentHLColor = options.color
            this.textListener.style.userSelect = 'none'
            this.textListener.addEventListener("mousedown", this.highlight2DrawMouseDownEventHandler, true)
            this.textListener.addEventListener("mouseup", this.highlight2DrawMouseUpEventHandler, true)
        }

        if (drawEvent == "clearTool") {
            for (var annotation of this.annotationMemory.getAnnotationArray()) {
                if (annotation.type == "drawing" || annotation.type == "square" || annotation.type == "circle") {
                    annotation.drawHitbox()
                }
            }
            this.textListener.addEventListener("mousedown", this.clearToolMouseDownEventHandler, true)
            this.textListener.addEventListener("mousemove", this.clearToolMouseMoveEventHandler, true)
            this.textListener.addEventListener("mouseup", this.clearToolMouseUpEventHandler, true)
            this.cursor = document.createElement("div")
            this.cursor.className = "cursor"
            this.cursor.id = "cursor"
            this.annotationListener.appendChild(this.cursor)
            this.textListener.addEventListener("mousemove", this.circleFollowMouse, true);
            this.textListener.addEventListener("scroll", this.circleFollowMouse, true);
            this.textListener.addEventListener("mouseout", this.circleFollowMouseOut, true);
            for (var child of this.textListener.childNodes) {
                child.style.cursor = "none"
            }

            this.setAllAnnotationPointerEvent("none")
            
            this.annotationMemory.setClearMode(true)
            this.textListener.style.cursor = "none"
            this.textListener.style.userSelect = "none"
        }

        if (drawEvent == "text") {
            this.textListener.style.cursor = "copy";
            this.textListener.addEventListener("click", this.textDrawEventHandler, true)
        }
    }

    setDrawMode(drawEvent, toolSize, options = null) {
        this.toolSize = toolSize
        this.options = options

        // destroy all event listeners
        this.deselectTool()

        //http://jsfiddle.net/loktar/dQppK/23
        if (drawEvent == "drawing") {
            if (this.annotationListener.getElementsByClassName("drawingTime").length == 0) {
                // create a canvas as big as the text layer to draw on...
                const drawingCanvas = document.createElement("canvas");
                const cBound = this.annotationListener.getBoundingClientRect()
                drawingCanvas.width = cBound.width
                drawingCanvas.height = cBound.height
                drawingCanvas.className = "drawingTime"
                drawingCanvas.style.position = "absolute"
                drawingCanvas.style.zIndex = 900
                drawingCanvas.style.top = 0
                drawingCanvas.style.left = 0

                this.annotationListener.parentNode.insertBefore(drawingCanvas, this.annotationListener.nextSibling)
                this.drawingCanvas = drawingCanvas
                this.drawingCanvas.addEventListener("mousedown", this.drawingDrawMouseDownEventHandler, true)
                this.drawingCanvas.addEventListener("mousemove", this.drawingDrawMouseMoveEventHandler, true)
                this.drawingCanvas.addEventListener("mouseup", this.drawingDrawMouseUpEventHandler, true)

                this.setAllAnnotationPointerEvent("none")

                return drawingCanvas
            }
        }
    }

    deselectAll() {
        for (var annotation of this.annotationMemory.getAnnotationArray()) {
            if (annotation.selected && annotation.type != "highlight" && this.annotationMemory.clearMode == false) { // TODO
                annotation.removeHitbox()
            }
        }
    }

    deselectTool() {
        this.eventDestroyers()
        this.eventCreators()

        if (this.drawingCanvas != null) this.drawingCanvas.remove()
        this.setAllAnnotationPointerEvent("auto")

        this.removeCssSelectRules()
    }

    removeCssSelectRules() {
        var ss = document.styleSheets[0]
        if ("insertRule" in ss) {
            
            for (var i = 0; i < ss.cssRules.length; i++) {
                var rule = ss.cssRules[i]
                if (rule.selectorText == "span::selection") {
                    ss.deleteRule(i) 
                }
            }
        }
    }

    setAllAnnotationPointerEvent(pointerEvent) {
        for (var annotation of this.annotationMemory.getAnnotationArray()) {
            if (annotation.type != "highlight") {
                annotation.canvas.style.pointerEvents = pointerEvent
            }
        }
    }

    setHiglightAnnotationPointerEvent(pointerEvent) {
        for (var annotation of this.annotationMemory.getAnnotationArray()) {
            if (annotation.type == "highlight") {
                annotation.highlightElement.style.pointerEvents = pointerEvent
            }
        }
    }

    setALlListenersPointerEvent(pointerEvent) {
        this.annotationListener.style.pointerEvents = pointerEvent
        this.canvasListener.style.pointerEvents = pointerEvent
        this.textListener.style.pointerEvents = pointerEvent
    }

    /* CREATORS */
    eventCreators() {
        this.textListener.addEventListener("click", this.deselectAllAnnotations, true) 
    }

    /* DESTROYERS */
    eventDestroyers() {
        this.textListener.style.cursor = "auto";
        this.textListener.removeEventListener("click", this.deselectAllAnnotations, true)
        this.textListener.removeEventListener("click", this.squareDrawEventHandler, true)
        this.textListener.removeEventListener("click", this.circleDrawEventHandler, true)
        this.textListener.removeEventListener("click", this.highlightDrawMouseClickEventHandler, true)
        this.textListener.removeEventListener("click", this.textDrawEventHandler, true)

        this.textListener.removeEventListener("mousedown", this.drawingDrawMouseDownEventHandler, true)
        this.textListener.removeEventListener("mousemove", this.drawingDrawMouseMoveEventHandler, true)
        this.textListener.removeEventListener("mouseup", this.drawingDrawMouseUpEventHandler, true)

        this.textListener.removeEventListener("mouseup", this.highlight2DrawMouseUpEventHandler, true)
        this.textListener.removeEventListener("mousedown", this.highlight2DrawMouseDownEventHandler, true)

        this.textListener.removeEventListener("mousedown", this.clearToolMouseDownEventHandler, true)
        this.textListener.removeEventListener("mousemove", this.clearToolMouseMoveEventHandler, true)
        this.textListener.removeEventListener("mouseup", this.clearToolMouseUpEventHandler, true)

        if (this.cursor != null) {
            this.cursor.remove()
            this.textListener.removeEventListener("mousemove", this.circleFollowMouse, true);
            this.textListener.removeEventListener("mouseout", this.circleFollowMouseOut, true);
            for (var child of this.textListener.childNodes) {
                child.style.cursor = "auto"
            }
            for (var annotation of this.annotationMemory.getAnnotationArray()) {
                if (annotation.type == "drawing" || annotation.type == "square" || annotation.type == "circle") {
                    annotation.removeHitbox()
                }
            }
            this.annotationMemory.setClearMode(false)
            this.textListener.style.cursor = "auto"
            this.textListener.style.userSelect = "auto"
        }
        this.textListener.style.userSelect = ''
    }

    /* Memory management */
    loadAnnotationMemory(annotations, annotationListener) {
        this.annotationMemory.loadAnnotations(annotations, annotationListener, this.zoomOptions)
        this.deselectTool()
    }

    exportAnnotations() {
        return this.annotationMemory.exportAnnotations()
    }

    undo() {
        this.annotationMemory.undoLastAction()
    }

    redo() {
        this.annotationMemory.redoLastUndo()
    }

    printUndo() {
        this.annotationMemory.printUndo()
    }

    printRedo() {
        this.annotationMemory.printRedo()
    }

    printMemory() {
        console.log(this.annotationMemory.getAnnotationArray())
    }

    rotateAnnotations(rotation) {
        if (rotation == 90 || rotation == 270) {
            this.orientation = "landscape"
        } else {
            this.orientation = "portrait"
        }
        for (var annotation of this.annotationMemory.getAnnotationArray()) {
            if (annotation.type != 'highlight') annotation.rotate(rotation)
        }
    }

    highlightSearch(searchString) {
        var results = []
        if (searchString.length < 1) {
            this.searchClear()
            return []
        } else {
            for (var child of this.textListener.childNodes) {
                if (child.innerText.toLowerCase().includes(searchString.toLowerCase())) {
                    child.innerHTML = child.innerText.replace( new RegExp( searchString + '(?!([^<]+)?<)', 'gi'), '<mark class="searchMark">$&</mark>')
                    results.push(child.innerText)
                }
            }
            return results
        }
    }
    searchClear() {
        let searchElements = document.getElementsByClassName("searchMark")

        for (let element of searchElements) {
            element.parentNode.innerHTML = element.parentNode.innerText
        }
    }

    removeAll(annotationType) {
        this.annotationMemory.removeAll(annotationType)
    }

    async textToSpeech(voice, rate, volume) {
        this.TTSVolume = volume
        this.TTSSpeed = rate
        this.TTSVoice = voice
        this.TTSGreetings = await new window.SpeechSynthesisUtterance()
        this.TTSSynth = window.speechSynthesis
        this.textListener.addEventListener("mouseup", this.saySomething, true)
    }

    pauseTextToSpeech() {
        if (this.TTSSynth) this.TTSSynth.pause()
    }

    resumeTextToSpeech() {
        if (this.TTSSynth) this.TTSSynth.resume()
    }

    stopTextToSpeech() {
        if (this.TTSSynth) this.TTSSynth.cancel()
    }

    cancelTextToSpeech() {
        if (this.TTSSynth) this.TTSSynth.cancel()
        this.textListener.removeEventListener("mouseup", this.saySomething, true)
    }

    setTTSVoice(voice) {
        this.TTSSynth.cancel()
        this.TTSVoice = voice
        this.TTSGreetings.voice = this.TTSVoice
    }

    setTTSRate(rate) {
        this.TTSSynth.cancel()
        this.TTSSpeed = rate
        this.TTSGreetings.rate = this.TTSSpeed / 10
    }

    setTTSVolume(volume) {
        this.TTSSynth.cancel()
        this.TTSVolume = volume
        this.TTSGreetings.volume = this.TTSVolume / 10
    }

    hideAll(hiding) {
        if (hiding == true) {
            for (var annotation of this.annotationMemory.getAnnotationArray()) {
                annotation.hide()
            }
        } else {
            for (var annotation of this.annotationMemory.getAnnotationArray()) {
                annotation.show()
            }
        }
    }
}
